// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:49:00

export default {
  "id": "labo-brick-train-game-for-kids",
  "slug": "labo-brick-train-game-for-kids",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/18b7534d6f744103bd5fad636f712463-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/18b7534d6f744103bd5fad636f712463/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Labo Brick Train Game For Kids",
      "description": "This is an assembly train game for all ages. Do you like small train toys? Have you ever wanted to assemble a beloved train by yourself? You can't miss our game if you are interested in all this.First of all, you need to pick out your favorite train style. Then start assembling the train from the locomotive, followed by the body.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "kidgames",
        "skill",
        "train"
      ]
    },
    "zh-CN": {
      "title": "儿童Labo积木火车游戏",
      "description": "这是一款适合所有年龄段的组装火车游戏。你喜欢小火车玩具吗？你有没有想过自己组装一辆心爱的火车？如果你对这一切都感兴趣，你绝对不能错过我们的游戏。首先，你需要挑选出你最喜欢的火车风格。然后，从机车开始组装火车，接着是车身。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "儿童游戏",
        "技巧",
        "训练"
      ]
    },
    "zh-TW": {
      "title": "Labo 砌砖火車遊戲 為兒童設計",
      "description": "這是一款適合所有年齡層的編裝火車遊戲。你喜歡小火車玩具嗎？你是否曾想親自組裝一輛心愛的火車？如果你對這些都感興趣，絕對不能錯過我們的遊戲。首先，你需要選擇你喜歡的火車風格。然後從機車開始，接著組裝車身。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "隨意"
      ],
      "tags": [
        "兒童遊戲",
        "技巧",
        "訓練"
      ]
    },
    "zh-HK": {
      "title": "Labo 雜石火車遊戲 小童版",
      "description": "這是一款適合所有年齡階段的組裝火車遊戲。你喜歡小型的火車玩具嗎？你曾經想要自己組裝一輛心愛的火車嗎？如果你對這些都感興趣，絕對不能錯過我們的遊戲。首先，你需要選擇你喜愛的火車風格。然後，從機車開始，接著是車身，開始組裝火車。",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "隨意"
      ],
      "tags": [
        "兒童遊戲",
        "技能",
        "訓練"
      ]
    },
    "ja": {
      "title": "ラボ ブリック レールトレイン ゲーム フォー キッズ",
      "description": "これは全年龄層向けの組み立てトレインゲームです。小さなトレインのおもちゃが好きですか？自分で大切なトレインを組み立てたいと思ったことはありますか？これらに興味がある場合は、私たちのゲームを見逃せません。まず最初に、お気に入りのトレインスタイルを選んでください。その後、機関車から始めて、ボディーに進んでトレインを組み立てましょう。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "キッドゲームズ",
        "スキル",
        "トレーニング"
      ]
    },
    "ko": {
      "title": "키즈 라보 브릭 트레인 게임",
      "description": "이는 모든 연령대를 위한 조립 기차 게임입니다. 작은 기차 장난감이 좋아하시나요? 귀하가 혼자서도 사랑하는 기차를 조립하고 싶어했나요? 이 모든 것에 관심이 있으시다면 우리의 게임을 놓치지 마세요. 먼저, 귀하의 좋아하는 기차 스타일을 선택해야 합니다. 그런 다음, 기차를 기관차부터 시작하여 몸체로 조립하세요.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "키드게임",
        "스킬",
        "훈련"
      ]
    },
    "fr": {
      "title": "Jeu de train en briques Labo pour enfants",
      "description": "C'est un jeu de train en assemblage pour tous les âges. Aimez-vous les petits jouets de trains ? Avez-vous jamais voulu assembler vous-même un train aimé ? Vous ne devriez pas manquer notre jeu si vous êtes intéressé par tout cela. Tout d'abord, vous devez choisir votre style de train préféré. Ensuite, commencez à assembler le train à partir du locomotive, suivi du châssis.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Accordéon"
      ],
      "tags": [
        "jeux pour enfants",
        "compétence",
        "entraînement"
      ]
    }
  }
};
